import React, { useEffect, useMemo } from "react";
import { getOneService, updateService } from "@payping/redux/actions";
import { DashboardRoutes } from "@/router/constant";
import {
  Button,
  Col,
  LegacyForm,
  Row,
  Skeleton,
  Space,
  Typography,
  useMessagedAsync,
  useMessagedAsyncFn,
} from "@payping/web-components";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "../../assets/scss/profile/Settings.module.scss";
import { SwitchRow } from "@/core/component";

interface MessagingFormType {
  getImportantNotifies: boolean;
  getPayNotify: boolean;
  sendInvoiceReminder: boolean;
}

const MessagingSection: React.FC = () => {
  const { t } = useAppTranslation();
  const dispatch = useAppDispatch();
  const oneService = useAppSelector((state) => state.service.oneService);
  const [form] = LegacyForm.useForm<MessagingFormType>();
  const navigate = useNavigate();

  const { loading: loadingGet } = useMessagedAsync(
    async () => {
      await dispatch(getOneService(11));
    },
    [dispatch],
    { useProgress: true },
  );

  const [{ loading: loadingEdit }, handleEdit] = useMessagedAsyncFn(
    async (values: MessagingFormType) => {
      await dispatch(updateService({ ...values, serviceType: 11 }));
      navigate(DashboardRoutes.profile.detail.url);
    },
    [dispatch, navigate],
    undefined,
    { useProgress: true },
  );

  const loading = useMemo(() => loadingGet || loadingEdit, [loadingGet, loadingEdit]);

  useEffect(() => {
    form.setFieldsValue({
      getImportantNotifies: oneService.getImportantNotifies,
      getPayNotify: oneService.getPayNotify,
      sendInvoiceReminder: oneService.sendInvoiceReminder,
    });
  }, [form, oneService]);

  return (
    <Space orientation={"vertical"} size={"middle"} className={"tw:w-full"}>
      <Typography.Title level={4} className="tw:font-medium">
        {t("settings.cards.notifications.title")}
      </Typography.Title>
      <Row className={"tw:w-full"}>
        <Col xs={24} sm={20} md={16} lg={12} xl={10}>
          <LegacyForm<MessagingFormType> onFinish={handleEdit} form={form}>
            <Typography.Text className={styles.grey}>{t("settings.messaging.email.title")}</Typography.Text>
            <LegacyForm.Item name={"getPayNotify"} valuePropName={"checked"}>
              {loading ? <Skeleton.Input /> : <SwitchRow label={t("settings.messaging.email.payMessage")} />}
            </LegacyForm.Item>
            <LegacyForm.Item name={"getImportantNotifies"} valuePropName={"checked"}>
              {loading ? <Skeleton.Input /> : <SwitchRow label={t("settings.messaging.email.importantOrAuth")} />}
            </LegacyForm.Item>
            <Typography.Text className={styles.grey}>{t("settings.messaging.sms.title")}</Typography.Text>
            <LegacyForm.Item name={"sendInvoiceReminder"} valuePropName={"checked"}>
              {loading ? <Skeleton.Input /> : <SwitchRow label={t("settings.messaging.sms.invoiceLink")} />}
            </LegacyForm.Item>
            <Space>
              <Button type={"primary"} loading={loading} htmlType={"submit"}>
                {t("enable")}
              </Button>

              <Button variant={"outlined"} color="primary" onClick={() => navigate(-1)}>
                {t("return")}
              </Button>
            </Space>
          </LegacyForm>
        </Col>
      </Row>
    </Space>
  );
};

export default MessagingSection;
